import { JarvisAuthPluginAuthProvider, JarvisWebHttpClient } from '@jarvis/web-http';
import { useBaseUrl, useExperimentsBaseUrl } from './envHooks';

export const usePhotobookApiWebHttpClient = () => {
  return new JarvisWebHttpClient({
    defaultBaseURL: useBaseUrl(),
    defaultAuthProvider: new JarvisAuthPluginAuthProvider(),
  });
};

export const useExperimentsWebHttpClient = () => {
  return new JarvisWebHttpClient({
    defaultBaseURL: useExperimentsBaseUrl(),
    defaultAuthProvider: new JarvisAuthPluginAuthProvider(),
  });
};
